export default {
  DASHBOARDS_URL2: "https://static.smartstake.io/resources/localdashboards.json",
  DASHBOARDS_URL: "https://static.smartstake.io/resources/dashboardsnew.json",
  networkLogoBaseUrl: "https://static.smartstake.io/chains/",
  assetsUrl: "https://static.smartstake.io/",
  HOME_NETWORK_KEY: "HOME_NETWORK_KEY_1",
  NETWORKS_KEY: "NETWORKS_V3",
  allNetworks: {"LUNA": "terra", "AKT": "akash", "ATOM": "cosmos", "BAND": "band", 
    "CORE": "coreum", "CRE": "crescent", "CRO": "crypto-org", "EVMOS": "evmos", 
    "FET": "fetch", "FLIX": "omniflix", "INJ": "injective", "JUNO": "juno", "KUJI": "kujira", 
    "MARS": "mars", "MATIC": "polygon", "OSMO": "osmosis", "QCK": "quicksilver", 
    "STARS": "stargaze", "STRD": "stride", "WHALE": "migaloo", "XPRT": "persistence", 
    "NTRN": "neutron", "TARCH": "archway", "BLD": "agoric", "ARCH": "archway", 
    "QSR": "quasar", "KYVE": "kyve", "SEI": "sei", "PASG": "passage", "DYDX": "dydx", 
    "TIA": "celestia", "IRIS": "irisnet", "FURY": "furya", "ANDR": "andromeda", 
    "UMEE": "ux", "DYM": "dymension"
  },
  basic: {
    baseKeyForValidators: "VALIDATORS_LIST_KEY_14_",
    baseKeyForProposals: "PROPOSALS_LIST_KEY_2_",
  },
  urls: {
    giniExplanation: "https://medium.com/@terra.validator.watchtower/terra-decentralization-july-2021-e9029d7a221b",
    nakamotoIndex: "https://crosstower.com/resources/education/nakamoto-coefficient/",
    aliasUrl: "https://www.github.com/smartstake/richlists",
  },
  integrations: {
    leap: "https://cosmos.leapwallet.io/transact/stake/plain?chain=",
    keplr: "https://wallet.keplr.app/chains/",
    mintscan: "https://mintscan.io/",
    pingpub: "https://ping.pub/",
    restake: "https://restake.app/",
    yieldmos: "https://www.yieldmos.com/strategies/",
    station: "https://station.terra.money/",
    logo: {
      keplr: "https://wallet.keplr.app/keplr-brand-assets/keplr-logo.svg",
      leap: "https://static.smartstake.io/integrations/leap.jpg",
      mintscan: "https://www.mintscan.io/assets/icons/cosmostation.png",
      pingpub: "https://ping.pub/assets/logo-fea46f13.svg",
      restake: "https://static.smartstake.io/integrations/restake.png",
      station: "https://static.smartstake.io/integrations/station.svg",
      yieldmos: "https://static.smartstake.io/integrations/yieldmos.png",
      coingecko: "https://static.smartstake.io/integrations/coingecko.jpg"
    }
  },
  enableTxs: true,
  removeOracleColumns: ["currentOraclePerSigned", "currentOracleMissed", "dailyOraclePerSigned", "dailyOracleMissed", "midOraclePerSigned", "midOracleMissed", "longOraclePerSigned", "longOracleMissed"],
  haltPower: 33.34,
  majorityPower: 66.67,
  commission: {
    maxChangeRate: 5,
    maxCommission: 20,
  },
  colors: {
    text: "white",
    chartColor1: "darkgray",
    chartColor2: "lightblue",
    chartColor3: "lightgreen",
    chartColor4: "#faa84b",
    chartColor5: "yellow",
    chartColor6: "purple",
    chartColor7: "green",
    chartColor8: "blue",
    chartColor9: "lightgray",
    chartColorBright: "red",

    "--color-text": "white",
    "--color-text-gray": "#6d738c",
    "--color-background": "#212024",
    "--color-smart-primary": "#faa84c",
    "--color-smart-primary-bright": "#ffc107",
    "--color-smart-main-surface": "#0f1011",
    "--color-smart-main-surface--accent": "#1b191b",
    "--color-custom-surface": "#17141a",
    chartColorsArray: ["#faa84b", "green", "red", "purple", "blue", "lightblue", "lightgreen", "lightgray", "yellow"],
    chartColorsArray2: ["#faa84b", "green", "red", "purple", "blue", "#F3B6F1", "#B46C8C", "#44C4CA", 
      "#15534C", "#6C4623", "#E2E062", "#3B1B1C","#8D4E60","#64333B","#319C9D","#523219",
      "lightgray", "#498F60", "#5BECFB", ],
  },
  screenTour: {
    validators: [
          {selector: '.view-tag', content: 'Filter validators by status'},
          {selector: '.tourFavorite', content: 'Select/unselect favorites (one-time setting)'},
          {selector: '.tourValName', content: 'Click validator name to open validator home page'},
          {selector: '.tourColumnSettings',content: 'Change comparison data for assessing validators (one-time setting)'},
          {selector: '.tourHelp',content: 'Show this help again. Click X or anywhere in the screen to close.'},
        ]
  },
  menuStyle: {
    borderRadius: '3px',  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
    background: 'rgba(255, 255, 255, 1)', padding: '2px 0',
    fontSize: '90%', position: 'fixed',
    overflow: 'auto', maxHeight: '50%',  
    zIndex: '998'
  },
  proposal: {
    vote: {"VOTE_OPTION_YES": "Yes",
      "VOTE_OPTION_NO": "No",
      "VOTE_OPTION_ABSTAIN": "Abstain",
      "VOTE_OPTION_NO_WITH_VETO": "Veto",
    },
    finalStatuses: ["PROPOSAL_STATUS_REJECTED", "PROPOSAL_STATUS_PASSED"],
    votingStatus: "PROPOSAL_STATUS_VOTING_PERIOD",
  },
  txs: {
    categories: [{category: "large", label: "Large", respLabel: "Large"}, 
      {category: "delegation", label: "Delegations", respLabel: "Del"}, 
      {category: "undelegation", label: "Undelegations", respLabel: "Undel"}, 
      {category: "redelegation", label: "Redelegations", respLabel: "Redel"},
      {category: "staking", label: "Staking", respLabel: "Staking"}, 
    ],
    categories2: [{category: "valupdate", label: "Val Updates", respLabel: "Val Updates"}],
    categoryTitles: {"large": "Recent Large Transactions", "staking": "Recent Staking Transactions", 
      "valupdate": "Recent Validator Updates", "delegation": "Recent Delegation Transactions", 
      "undelegation": "Recent Undelegation Transactions", "redelegation": "Recent Redelegation Transactions"}
  }
};
